import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { Button, Form, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import usePalette from '../../../../../../hooks/usePalette';
import CurrencyInput from 'react-currency-input-field';
import numeral from 'numeral';
import Select from 'react-select';

// Icons
import Icon from '@mdi/react';
import { mdiCheckBold, mdiCloseThick, mdiPlusBox, mdiDelete } from '@mdi/js';

// redux
import {
  deleteFinancialCeilingFlow,
  updateFinancialCeilingFlow,
  updateScopeFinancial,
} from '../../../../../../redux/slices/projects/projectsSlice';

const AdminView = ({
  isEdit,
  handleEditTable,
  handleCloseTable,
  disableBtn,
  handleSaveProjectCeilingFlow,
  handleAddScopeProject,
  handleAddCeilingFlow,
  handleRemoveScopeProject,
  handleChangeScope,
  ceilingFlowScopeOptions,
  handleSaveScopeProject,
  ceilingFlowData,
  handleChangeScopeCeilingFlow,
}) => {
  const dispatch = useDispatch();
  const palette = usePalette();

  const { scopeFinancialList, projectScopeOptions } = useSelector((state) => ({
    scopeFinancialList: state.projectReducer.scopeFinancialList,
    projectScopeOptions: state.utilsReducer.dropdownItems.projectScopeItems,
  }));

  return (
    <React.Fragment>
      <div className="mb-3">
        <div className="d-flex justify-content-end mb-3">
          <Button
            size="sm"
            onClick={handleAddScopeProject}
            disabled={isEdit.project_scope_financial}
          >
            + Skop Projek
          </Button>
        </div>
        <div className="table-responsive">
          <Table size="sm">
            <thead className="custom-table-head text-uppercase">
              <tr>
                <th className="text-center">Bil.</th>
                <th>Skop Projek</th>
                <th>Kos Dipohon (RM)</th>
                <th>Kos Disemak (RM)</th>
                <th>Siling (RM)</th>
                <th>Siling Disemak (RM)</th>
                <th className="text-center">Tindakan</th>
              </tr>
            </thead>
            <tbody>
              {scopeFinancialList?.map((item, idx) => {
                return (
                  <tr key={idx}>
                    <td className="text-center">{idx + 1}</td>
                    <td style={{ width: '45%' }}>
                      <Select
                        isDisabled={isEdit.project_scope_financial}
                        value={
                          projectScopeOptions.find((opt) => opt.value === item.cost_description) ||
                          null
                        }
                        onChange={(selected) =>
                          handleChangeScope(
                            { target: { value: selected ? selected.value : '' } },
                            item
                          )
                        }
                        options={projectScopeOptions}
                        placeholder="Pilih skop"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                      />
                    </td>
                    <td>
                      <Form.Control
                        className="text-end"
                        placeholder="0.00"
                        as={CurrencyInput}
                        min={0}
                        autoComplete="off"
                        decimalsLimit={2}
                        decimalScale={2}
                        disabled={isEdit.project_scope_financial}
                        value={item?.cost_required}
                        onValueChange={(value) => {
                          const newValues = {
                            ...item,
                            cost_required: value,
                          };
                          dispatch(updateScopeFinancial(newValues));
                        }}
                      />
                    </td>
                    <td>
                      <Form.Control
                        className="text-end"
                        placeholder="0.00"
                        as={CurrencyInput}
                        min={0}
                        autoComplete="off"
                        decimalsLimit={2}
                        decimalScale={2}
                        disabled={isEdit.project_scope_financial}
                        value={item?.revised_cost_required}
                        onValueChange={(value) => {
                          const newValues = {
                            ...item,
                            revised_cost_required: value,
                          };
                          dispatch(updateScopeFinancial(newValues));
                        }}
                      />
                    </td>

                    <td>
                      <Form.Control
                        className="text-end"
                        placeholder="0.00"
                        as={CurrencyInput}
                        min={0}
                        autoComplete="off"
                        decimalsLimit={2}
                        decimalScale={2}
                        disabled={isEdit.project_scope_financial}
                        value={item?.ceiling}
                        onValueChange={(value) => {
                          const newValues = {
                            ...item,
                            ceiling: value,
                          };
                          dispatch(updateScopeFinancial(newValues));
                        }}
                      />
                    </td>
                    <td>
                      <Form.Control
                        className="text-end"
                        placeholder="0.00"
                        as={CurrencyInput}
                        min={0}
                        autoComplete="off"
                        decimalsLimit={2}
                        decimalScale={2}
                        disabled={isEdit.project_scope_financial}
                        value={item?.revised_ceiling}
                        onValueChange={(value) => {
                          const newValues = {
                            ...item,
                            revised_ceiling: value,
                          };
                          dispatch(updateScopeFinancial(newValues));
                        }}
                      />
                    </td>
                    <td>
                      <div className="d-flex justify-content-center gap-3">
                        <IconButton
                          size="small"
                          disabled={isEdit.project_scope_financial}
                          sx={{ color: palette.danger }}
                          onClick={() => handleRemoveScopeProject(item.id)}
                        >
                          <Icon path={mdiDelete} size="18px" />
                        </IconButton>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        <div className="d-flex justify-content-end gap-3">
          {isEdit.project_scope_financial ? (
            <>
              <Tooltip title="Ubah Skop Projek" arrow>
                <Button size="sm" onClick={() => handleEditTable('project_scope_financial')}>
                  Ubah
                </Button>
              </Tooltip>
            </>
          ) : (
            <>
              <Tooltip title="Simpan skop projek" arrow>
                <Button size="sm" variant="success" onClick={handleSaveScopeProject}>
                  <Icon path={mdiCheckBold} size={0.7} />
                </Button>
              </Tooltip>
              <Tooltip title="Batal" arrow>
                <Button
                  size="sm"
                  variant="light"
                  onClick={() => handleCloseTable('project_scope_financial')}
                >
                  <Icon path={mdiCloseThick} size={0.7} />
                </Button>
              </Tooltip>
            </>
          )}
        </div>
      </div>

      <div className="mb-3">
        <div className="table-responsive">
          <Table size="sm">
            <thead className="custom-table-head text-uppercase">
              <tr>
                <th className="text-center">Bil.</th>
                <th>Skop Projek</th>
                <th>Siling (RM)</th>
                <th>Siling Disemak (RM)</th>
                <th className="text-center">Tindakan</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(ceilingFlowData).map(([year, items], idx) => {
                return (
                  <React.Fragment key={year}>
                    <tr>
                      <td />
                      <td colSpan={2} className="fw-bolder">
                        Tahun {year}
                      </td>
                      <td className="text-center">
                        <Tooltip title="Tambah aliran siling" arrow>
                          <span>
                            <IconButton
                              size="small"
                              sx={{ color: palette.primary }}
                              onClick={() => handleAddCeilingFlow(year)}
                              disabled={isEdit.ceiling_flow}
                            >
                              <Icon path={mdiPlusBox} size="18px" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </td>
                    </tr>
                    {items.map((item, subIdx) => {
                      return (
                        <tr key={subIdx}>
                          <td className="text-center">{subIdx + 1}</td>
                          <td style={{ width: '45%' }}>
                            <Select
                              isDisabled={isEdit.ceiling_flow}
                              value={
                                ceilingFlowScopeOptions
                                  .map((opt) => ({
                                    value: opt.cost_description,
                                    label: opt.cost_description,
                                    id: opt.id,
                                  }))
                                  .find((opt) => opt.value === item.cost_description) || null
                              }
                              onChange={(selected) =>
                                handleChangeScopeCeilingFlow(
                                  {
                                    target: {
                                      value: selected ? selected.value : '',
                                      id: selected ? selected.id : '',
                                    },
                                  },
                                  item
                                )
                              }
                              options={ceilingFlowScopeOptions.map((opt) => ({
                                value: opt.cost_description,
                                label: opt.cost_description,
                                id: opt.id,
                              }))}
                              placeholder="Pilih skop"
                              isClearable
                              menuPortalTarget={document.body}
                              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                            />
                          </td>
                          <td>
                            <Form.Control
                              className="text-end"
                              placeholder="0.00"
                              as={CurrencyInput}
                              min={0}
                              autoComplete="off"
                              decimalsLimit={2}
                              decimalScale={2}
                              disabled={isEdit.ceiling_flow}
                              value={item?.amount || '0.00'}
                              onValueChange={(value) => {
                                const newValues = {
                                  ...item,
                                  amount: value,
                                };
                                dispatch(updateFinancialCeilingFlow(newValues));
                              }}
                            />
                          </td>
                          <td>
                            <Form.Control
                              className="text-end"
                              placeholder="0.00"
                              as={CurrencyInput}
                              min={0}
                              autoComplete="off"
                              decimalsLimit={2}
                              decimalScale={2}
                              disabled={isEdit.ceiling_flow}
                              value={item?.revised_amount || '0.00'}
                              onValueChange={(value) => {
                                const newValues = {
                                  ...item,
                                  revised_amount: value,
                                };
                                dispatch(updateFinancialCeilingFlow(newValues));
                              }}
                            />
                          </td>
                          <td>
                            <div className="d-flex justify-content-center gap-3">
                              <IconButton
                                size="small"
                                sx={{ color: palette.danger }}
                                disabled={isEdit.ceiling_flow}
                                onClick={() => dispatch(deleteFinancialCeilingFlow(item.id))}
                              >
                                <Icon path={mdiDelete} size="18px" />
                              </IconButton>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        </div>

        <div className="d-flex justify-content-end gap-3">
          {isEdit.ceiling_flow ? (
            <>
              <Tooltip
                title={disableBtn ? 'Sila simpan/batal maklumat skop projek' : 'Ubah aliran siling'}
                arrow
              >
                <span>
                  <Button
                    size="sm"
                    onClick={() => handleEditTable('ceiling_flow')}
                    disabled={disableBtn}
                  >
                    Ubah
                  </Button>
                </span>
              </Tooltip>
            </>
          ) : (
            <>
              <Tooltip title="Simpan aliran siling" arrow>
                <Button size="sm" variant="success" onClick={handleSaveProjectCeilingFlow}>
                  <Icon path={mdiCheckBold} size={0.7} />
                </Button>
              </Tooltip>
              <Tooltip title="Batal" arrow>
                <Button size="sm" variant="light" onClick={() => handleCloseTable('ceiling_flow')}>
                  <Icon path={mdiCloseThick} size={0.7} />
                </Button>
              </Tooltip>
            </>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdminView;
